import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListaProfissionaisComponent } from '../cadastro/profissional/lista-profissionais/lista-profissionais.component';
import { CadastrarProfissionaisComponent } from '../cadastro/profissional/cadastrar-profissionais/cadastrar-profissionais.component';
import { MainLayoutComponent } from 'src/app/shared/main-layout/main-layout.component';
import { UnidadeListaComponent } from './unidades/unidade-lista/unidade-lista.component';
import { ExameListaComponent } from './exame/exame-lista/exame-lista.component';
import { FuncionarioListaComponent } from './funcionario/funcionario-lista/funcionario-lista.component';
import { CondicionalListaComponent } from './condicional/condicional-lista/condicional-lista.component';
import { pageAccessGuard } from '../guard/page-access.guard';

const routes: Routes = [
  { 
    path: 'funcionarios', component: FuncionarioListaComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'funcionarios'
    }
  },
  {
    path: 'profissionais',
    component: ListaProfissionaisComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'profissionais'
    }
  },
  {
    path: 'profissionais/cadastrar',
    component: CadastrarProfissionaisComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'profissionais/cadastrar'
    }
  },
  {
    path: 'unidades',
    component: UnidadeListaComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'unidades'
    }
    
  },
  {
    path: 'exames',
    component: ExameListaComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'exames'
    }
  },
  {
    path: 'condicionais',
    component: CondicionalListaComponent,
    canActivate: [pageAccessGuard],
    data: {
      access: 'condicionais'
    }
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CadastroRoutingModule { }
